export default __webpack_public_path__ + "static/media/MLERT.7b6dae8d.png";